import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Booking from "@/pages/Booking";
import StaffLogin from "@/pages/StaffLogin";
import StaffDashboard from "@/pages/StaffDashboard";
import Kiosk from "@/pages/Kiosk";
import NotFound from "@/pages/NotFound";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/book" element={<Booking />} />
                    <Route path="/staff/login" element={<StaffLogin />} />
                    <Route path="/staff" element={<StaffDashboard />} />
                    <Route path="/kiosk" element={<Kiosk />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-right" />
        </div>
    );
}

export default App;
